// Ce qu'un rendu « après » doit montrer, et quand il est périmé (audit du
// deviseur, 12/10/2026). Module pur.

// Les postes d'un logement entier qui se voient dans une pièce : radiateurs,
// éclairage, VMC. Ils vivent dans « Installations techniques — <logement> »
// mais le rendu de chaque pièce du logement doit les montrer.
const VISIBLES_LOGEMENT = ['chauffage.radiateur_eau', 'chauffage.robinet_thermostatique', 'electricite.points_m2', 'electricite.vmc_simple_flux', 'chauffage.radiateurs_electriques_logement'];

/** Lignes à montrer dans le rendu d'une pièce : les siennes + celles de son logement qui se voient. */
export function lignesPourRendu(room, rooms, niveauDe) {
  const propres = room.lines || [];
  const niv = niveauDe ? niveauDe(room) : room.niveau;
  const tech = (rooms || []).find(r => r.technique && r.technique !== room.technique && (niveauDe ? niveauDe(r) : r.niveau) === niv);
  const ajout = (tech?.lines || []).filter(l => VISIBLES_LOGEMENT.includes(l.key) && !propres.some(p => p.key === l.key)).map(l => ({ key: l.key, qty: 1 }));
  return [...propres.map(l => ({ key: l.key, qty: l.qty })), ...ajout];
}

/** Consignes du rendu : celles posées sur la pièce, sinon le style décrit par le client — jamais les notes d'analyse. */
export function briefPourRendu(room, clientBrief) {
  const b = room.aiBrief != null ? room.aiBrief : clientBrief;
  return (b || '').trim() || undefined;
}

/** La photo « avant » : celle déjà rendue, sinon la première qui n'est ni un plan ni un document. */
export function photoAvant(room) {
  const photos = (room.photos || []).filter(p => p && p.id);
  if (room.afterPhoto?.fromPhotoId && photos.some(p => p.id === room.afterPhoto.fromPhotoId)) return room.afterPhoto.fromPhotoId;
  const vraie = photos.find(p => !/^plan\b|document|scan|devis|facture/i.test(p.caption || ''));
  return (vraie || photos[0])?.id || null;
}

/** Empreinte de ce que montre un rendu : postes + style. Différente = rendu périmé. */
export function empreinteRendu(lignes, style) {
  const s = JSON.stringify([[...new Set((lignes || []).map(l => l.key))].sort(), ['ambiance', 'wallColor', 'floorTone', 'lighting'].map(k => style?.[k]?.label || null)]);
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return String(h);
}

/** Un rendu existe mais ne correspond plus aux postes ou au style. Un rendu sans empreinte (ancien) n'est pas déclaré périmé. */
export function renduPerime(room, rooms, style, niveauDe) {
  const a = room.afterPhoto;
  if (!a?.url || !a.empreinte) return false;
  return a.empreinte !== empreinteRendu(lignesPourRendu(room, rooms, niveauDe), style);
}
